<template>
  <div>
    <v-btn @click="openTabSettings" color="primary" icon><v-icon>mdi-dots-vertical</v-icon></v-btn>
    <v-dialog width="700" v-model="openModal">
      <v-card>
        <v-card-title class="headline">{{$t('tabsettings_tab_settings')}}</v-card-title>

        <v-card-text>
          <div class="my-5">
            <div class="text-caption font-weight-bold label">{{$t('tabsettings_tab_name')}}:</div>
            <v-text-field
              counter
              dense
              v-model="form.name"
              maxlength="16"
              :placeholder="$t('tabsettings_tab_name_placeholder')">
            </v-text-field>
          </div>

          <div class="my-5">
            <div class="text-caption font-weight-bold label">{{$t('tabsettings_tab_icon')}}:</div>
            <icon-picker v-on:selectIcon="selectIcon" :active="form.icon"></icon-picker>
          </div>

          <div v-if="isAvailable('editor:authentication')" class="checkbox-ctn">
            <div class="text-caption font-weight-bold label">{{$t('tabsettings_shown_for_scan_result')}}:</div>
            <v-checkbox hide-defails dense class="ma-0 pa-0" :label="$t('genuine')" v-model="form.visibility.genuine"></v-checkbox>
            <v-checkbox hide-defails dense class="ma-0 pa-0" :label="$t('active_code')" v-model="form.visibility.active"></v-checkbox>
            <v-checkbox hide-defails dense class="ma-0 pa-0" :label="$t('unable_to_verify')" v-model="form.visibility.fake"></v-checkbox>
          </div>

        </v-card-text>

        <v-card-actions>
          <v-btn text color="red" @click="deleteTab">{{$t('tabsettings_remove_this_tab')}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="close">{{$t('close')}}</v-btn>
          <v-btn text @click="save" color="primary">{{$t('save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import IconPicker from '@/components/utils/IconPicker'

export default {
  name: 'TabSettings',
  props: ['tabId', 'name', 'icon'],
  components: {
    IconPicker
  },
  computed: {
    ...mapGetters(['getTabVisibility', 'isAvailable'])
  },
  data () {
    return {
      openModal: false,
      form: {
        name: '',
        visibility: {},
        icon: ''
      }
    }
  },
  watch: {
    tabId (newVal) {
      if (newVal !== this.form.tabId) {
        this.form.visibility = this.getTabVisibility(this.tabId)
        this.form.tabId = this.tabId
        this.form.name = this.name
        this.form.icon = this.icon
      }
    }
  },
  methods: {

    deleteTab () {
      this.$emit('delete-tab', this.tabId)
      this.openModal = false
    },

    selectIcon (icon) {
      this.form.icon = icon
    },

    openTabSettings () {
      this.openModal = true
    },

    close () {
      this.openModal = false
    },

    save () {
      this.$store.dispatch('updateTabName', { tabId: this.tabId, name: this.form.name })
      this.$store.dispatch('updateTabIcon', { tabId: this.tabId, icon: this.form.icon })
      console.log('1 - UPDATING TAB' + this.tabId)
      this.$store.dispatch('updateTabVisibility', { tabId: this.tabId, visibility: this.form.visibility })
      this.openModal = false
    }
  },
  created () {
    this.form.visibility = this.getTabVisibility(this.tabId)
    this.form.tabId = this.tabId
    this.form.name = this.name
    this.form.icon = this.icon
  }
}

</script>

<style lang="sass">

@import '@/variables.sass'

.checkbox-ctn
  .label
    text-transform: uppercase
    color: $label-grey
  .v-messages
    display: none
  .v-input__slot
    margin-bottom: 0 !important
    label
      color: black

</style>
